import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=d124fa66&"
import script from "./Modal.vue?vue&type=script&lang=ts&"
export * from "./Modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d124fa66')) {
      api.createRecord('d124fa66', component.options)
    } else {
      api.reload('d124fa66', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=d124fa66&", function () {
      api.rerender('d124fa66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/components/utilities/Modal.vue"
export default component.exports